/**
 * Programmatically copy a text to the users clipboard
 * @param text - The text to copy to the clipboard
 * @returns A promise that resolves when the text has been copied
 * https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText
 */
export async function writeClipboardText(text: string): Promise<void> {
    try {
        await navigator.clipboard.writeText(text);
    } catch (error) {
        if (error instanceof Error) {
            console.error(error.message);
        } else {
            console.error(error);
        }
    }
}
